import { Component, computed, input} from '@angular/core';
import { CommonModule } from '@angular/common';

type ToastType = 'error' | 'success' | null;
@Component({
  selector: 'cp-toast',
  imports: [
    CommonModule
  ],
  template: `
    <div class="py-4 pr-6 pl-4 rounded-lg shadow w-110 flex flex-col" [ngStyle]="computedStyles()">
      <label hlmLabel class="text-base font-semibold">{{ header() }}</label>
      <label hlmLabel class="text-sm">{{ message() }}</label>
    </div>
    `
})
export class ToastComponent {

  public type = input<ToastType>();
  public message = input<string>('');
  public header = input<string>('');

  public computedStyles = computed(()=> {
    let styles;
    switch (this.type()) {
      case 'success':
        styles = {
          'background-color': '#EDF6E9',
          'color': '#216F00',
          'border': '1px solid #2C9400'
        }
        break;
      case 'error': 
        styles = {
          'background-color': '#DC2626',
          'color': '#FFFFFF'
        }
        break;
      default:
        break;
    }
    return styles;
  })  
 }
